var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col s6 m6"},[_c('div',{staticClass:"card white"},[_c('div',{staticClass:"card-content gray-text"},[_c('span',{staticClass:"card-title"},[_vm._t("title")],2),_vm._v(" "),_c('p',[_vm._t("descricao")],2)]),_vm._v(" "),_c('div',{staticClass:"card-action",staticStyle:{"cursor":"pointer"}},[_vm._t("action")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }